import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {
	JOURNAL_PATH,
	SANDBOX_PATH,
	CHANGELOG_PATH,
	USER_SELECT_PATH,
	AUTH_PATH,
	EMPTY_PATH,
	LOGGED_OUT_PATH, NOT_FOUND
} from 'projects/shared/src/magic';
import {UserGuard} from 'projects/user/src/lib/user.guard';
import {PreprodDisabledGuard} from '../../projects/journal/src/_resolvers/preprod-disabled.guard';
import {SettingsInStoreGuard} from '../../projects/settings/_guards/settings-in-store.guard';
import {JournalInitGuard} from '../../projects/journal/src/_resolvers/journal-init.guard';
import {JournalDestroyGuard} from '../../projects/journal/src/_resolvers/journal-destroy.guard';
import {ProdDisabledGuard} from '../../projects/journal/src/_resolvers/prod-disabled.guard';
import {LayoutComponent} from '../../projects/layout/src/lib/layout/layout.component';

const routes: Routes = [
	{
		path: LOGGED_OUT_PATH,
		pathMatch: 'full',
		loadComponent: () => import('src/app/auth/logged-out/logged-out.component').then(m => m.LoggedOutComponent)
	},
	{
		path: AUTH_PATH,
		loadChildren: () => import('src/app/auth/auth.module').then(u => u.AuthModule)
	},
	{
		path: EMPTY_PATH,
		component: LayoutComponent,
		children: [
			{
				path: JOURNAL_PATH,
				canActivate: [
					UserGuard,
					JournalInitGuard
				],
				canActivateChild: [
					SettingsInStoreGuard
				],
				canDeactivate: [
					JournalDestroyGuard
				],
				loadChildren: () => import('projects/journal/src/lib/journal.module').then(m => m.JournalModule)
			},
			{
				path: SANDBOX_PATH,
				// todo: change this to normal redirect to overview & and possibly 404
				canActivate: [PreprodDisabledGuard],
				loadChildren: () => import('src/app/sandbox/sandbox.module').then(m => m.SandboxModule)
			},
			{
				path: CHANGELOG_PATH,
				canActivate: [ProdDisabledGuard],
				loadChildren: () => import('src/app/changelog/changelog.module').then((c => c.ChangelogModule))
			},
			{
				path: USER_SELECT_PATH,
				canActivate: [PreprodDisabledGuard],
				loadChildren: () => import('projects/user/src/lib/user.module').then(u => u.UserModule),
			},
			{
				path: '',
				pathMatch: 'full',
				// todo: refactor this to a redirect to journal overview -> waiting for a new development (DM v2.0)
				redirectTo: AUTH_PATH

			}
		]
	},
	{
		path: NOT_FOUND,
		loadComponent: () => import('projects/layout/src/lib/layout/page-not-found/page-not-found.component')
			.then(m => m.PageNotFoundComponent)
	},
	{
		path: '**',
		redirectTo: NOT_FOUND
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
